import { render, staticRenderFns } from "./PaintIcon.vue?vue&type=template&id=33484604&"
import script from "./PaintIcon.vue?vue&type=script&lang=js&"
export * from "./PaintIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports